import { c as _c } from "react-compiler-runtime";
import { Children, useContext } from 'react';
import I18n from 'I18n';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
const childrenToArray = children => {
  const result = [];
  Children.forEach(children, child => {
    result.push(child);
  });
  return result;
};
const listOptionKeys = new Set(['excessKey', 'exclusive', 'lastWordConnector', 'limit', 'locale', 'twoWordsConnector', 'wordsConnector']);
function FormattedList(props) {
  const $ = _c(7);
  useContext(I18nHMRContext);
  let passThrough;
  if ($[0] !== props) {
    passThrough = {};
    Object.keys(props).forEach(key => {
      if (!listOptionKeys.has(key)) {
        passThrough[key] = props[key];
      }
    });
    $[0] = props;
    $[1] = passThrough;
  } else {
    passThrough = $[1];
  }
  let t0;
  if ($[2] !== props) {
    t0 = I18n.formatListArray(childrenToArray(props.children), props);
    $[2] = props;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== passThrough || $[5] !== t0) {
    t1 = /*#__PURE__*/_jsx("span", Object.assign({}, passThrough, {
      children: t0
    }));
    $[4] = passThrough;
    $[5] = t0;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}
FormattedList.displayName = 'FormattedList';
export default FormattedList;